"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransformKeyFrame = createTransformKeyFrame;
var theme_1 = require("../theme");
function createTransformKeyFrame(name, transformFrom, transformTo) {
    var _a;
    (0, theme_1.addStyles)((_a = {},
        _a["@keyframes ".concat(name)] = { from: { transform: transformFrom }, to: { transform: transformTo } },
        _a));
}
//# sourceMappingURL=transform.js.map